import { useQuery } from "@tanstack/react-query";
import studentApi from "../../api/studentApi";

interface NotAssignedClassParams {
    page?: number;
    limit?: number;
}

export const useGetStudentNotAssignedClass = (params: NotAssignedClassParams) => {
    return useQuery({
        queryKey: ["student-not-assigned-class", params],
        queryFn: () => studentApi.getStudentNotAssignedClass(params),
        placeholderData: (previousData) => previousData,
    });
};